<template>
    <div class="product--body product--body--item">
        <div class="col-12 d-flex align-items-center">
            <div class="col-2">
                <img v-if="item.season == 'IN'" width="100%" src="/static/invierno.png" alt="">
                <img v-else-if="item.season == 'VR'" width="100%" src="/static/verano.png" alt="">
                <div v-else>
                    <img width="100%" src="/static/invierno.png" alt="">
                    <img width="100%" src="/static/verano.png" alt="">
                </div>
            </div>
            <h3 class="pl-2 product--body--description flex--weight--1">
                {{ item.person }}
                <small v-if="item.maximum_age < 75" class="d-block">
                    Edad: {{item.minimum_age}} - {{item.maximum_age}} años
                </small>
                <small v-else class="d-block">
                    Edad: {{item.minimum_age}}+ años
                </small>

                <small class="d-block">
                    <span v-if="item.weekday_prices">Desde</span> {{ item.unit_price | currency}}
                    <span class="line-through rack--price" v-if="parseFloat(item.rack_price)">{{ item.rack_price | currency}}</span>
                </small>
            </h3>

            <div class="col mt-3 mb-3 text-right d-flex no-wrap">
                <button class="btn btn-primary btn-lg my-1" @click="toCheckout">Seleccionar</button>
            </div>
        </div>
    </div>
</template>

<script>

    import siteConfig from '../mixins/siteConfig';


    export default {
        props: {
            data: {
                type: Object,
                required: true
            },
            increase: {
                type: Function,
                required: true,
            },
            decrease: {
                type: Function,
                required: true
            },
            iconColor: {
                type: String,
                default() {
                    return '#166ba6';
                }
            }
        },

        mixins: [siteConfig],

        data() {
            return {
                item: this.data
            }
        },
        methods: {
            toCheckout: function () {
                const cart = localStorage.getItem("passes_cart");
                const params = cart ? cart+"/"+this.item.id : '';
                window.location.href = `${this.getUrl('createpasseUrl')}${params}`;
            }
        },

    }
</script>



// WEBPACK FOOTER //
// src/components/PasseProduct.vue